<button mat-icon-button type="button" class="wd-trigger"
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
        aria-label="Why does this show 'various'?">
    <mat-icon>info_outline</mat-icon>
</button>

<mat-menu #menu="matMenu" class="weighting-divergence-menu">
    <div class="wd-panel" (click)="$event.stopPropagation()">
        <p class="wd-heading">These fund valuations differ from the weightings defined in the settings</p>
        <table class="wd-table">
            <thead>
                <tr>
                    <th>Fund</th>
                    <th>Valuation</th>
                    <th class="wd-num">Weighting (L / B / H)</th>
                </tr>
            </thead>
            <tbody>
                @for (divergence of divergences; track $index) {
                    <tr>
                        <td class="wd-fund">{{ divergence.fundName }}</td>
                        <td>{{ divergence.fundValuationDescription }}</td>
                        <td class="wd-num">{{ weightingLabel(divergence) }}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <a mat-menu-item routerLink="/settings" [queryParams]="{tab: 'GENERAL', scope: settingsScope}">
        <mat-icon>settings</mat-icon>
        <span>Open weighting settings</span>
    </a>
</mat-menu>
